/**
 * Front-end filtering for mea/careers-feed - Figma "20. careers" node
 * 2008-8216, "Dept Pills" (2008:8289).
 *
 * The server renders EVERY published role and no pressed pill, so the section
 * is complete and correct with this script absent or blocked. All this file
 * does is narrow what is already there; it never builds the list.
 *
 * Markup rendered by render.php:
 *
 *   <section class="mea-careers-feed">
 *     <div class="mea-careers-feed__filters" role="group" aria-label="...">
 *       <button class="mea-careers-feed__pill" aria-pressed="false"
 *               data-mea-careers-filter="{job_function}">...</button>
 *     </div>
 *     <p data-mea-careers-status data-template="Showing {shown} of {total}...">
 *     <ul data-mea-careers-list>
 *       <li class="mea-careers-feed__item" data-mea-careers-function="{job_function}">
 *     </ul>
 *     <p data-mea-careers-empty data-template="No open roles in {department}..." hidden>
 *   </section>
 *
 * Accessibility notes:
 *  - The pills are real <button> elements, so Tab reaches them and both Enter
 *    and Space activate them with no key handling of our own. Adding a
 *    roving-tabindex toolbar here would take keys away from the user for no
 *    gain, so the native behavior is left alone.
 *  - `aria-pressed` is the single source of truth for state: the stylesheet
 *    paints the selected pill off that same attribute, so what a screen reader
 *    is told and what is on screen cannot drift apart.
 *  - Pressing the active pill again clears the filter. Figma draws no "All"
 *    chip, so the pill itself is the way back to the full list, and the
 *    unfiltered state stays reachable by keyboard.
 *  - Cards are hidden with the `hidden` attribute rather than a class, which
 *    takes them out of the accessibility tree as well as the layout.
 *  - The result count lives in a role="status" region, so a filter change is
 *    announced instead of happening silently.
 */
( function () {
	'use strict';

	/**
	 * Fill {token} placeholders in an editable copy string.
	 *
	 * @param {string} template Copy from a block attribute.
	 * @param {Object} values   Token name to replacement value.
	 * @return {string} The filled string.
	 */
	function fill( template, values ) {
		return Object.keys( values ).reduce( function ( text, token ) {
			return text.split( '{' + token + '}' ).join( values[ token ] );
		}, template || '' );
	}

	/**
	 * Wire one block instance. Several can share a page.
	 *
	 * @param {HTMLElement} root The block root.
	 */
	function setup( root ) {
		var pills = Array.prototype.slice.call(
			root.querySelectorAll( '[data-mea-careers-filter]' )
		);
		var items = Array.prototype.slice.call(
			root.querySelectorAll( '[data-mea-careers-function]' )
		);

		if ( ! pills.length || ! items.length ) {
			return;
		}

		var status = root.querySelector( '[data-mea-careers-status]' );
		var empty = root.querySelector( '[data-mea-careers-empty]' );
		var total = items.length;

		/**
		 * Apply a filter. An empty department means "show everything".
		 *
		 * @param {string} department A job_function value, or ''.
		 */
		function apply( department ) {
			var shown = 0;

			items.forEach( function ( item ) {
				var match =
					'' === department ||
					item.getAttribute( 'data-mea-careers-function' ) === department;

				if ( match ) {
					item.removeAttribute( 'hidden' );
					shown++;
				} else {
					item.setAttribute( 'hidden', '' );
				}
			} );

			pills.forEach( function ( pill ) {
				var active =
					'' !== department &&
					pill.getAttribute( 'data-mea-careers-filter' ) === department;

				pill.setAttribute( 'aria-pressed', active ? 'true' : 'false' );
			} );

			if ( status ) {
				status.textContent = fill( status.getAttribute( 'data-template' ), {
					shown: shown,
					total: total,
				} );
			}

			/*
			 * The pills are derived from the values present in the rendered
			 * roles, so every pill matches at least one card and this branch
			 * does not fire today. It exists so a filter can never leave the
			 * section showing a blank area.
			 */
			if ( empty ) {
				if ( 0 === shown ) {
					empty.textContent = fill( empty.getAttribute( 'data-template' ), {
						department: department,
					} );
					empty.removeAttribute( 'hidden' );
				} else {
					empty.setAttribute( 'hidden', '' );
				}
			}
		}

		pills.forEach( function ( pill ) {
			pill.addEventListener( 'click', function () {
				var department = pill.getAttribute( 'data-mea-careers-filter' );
				var wasActive = 'true' === pill.getAttribute( 'aria-pressed' );

				// Single-select, as drawn: a second press on the active pill
				// clears the filter rather than leaving the user stuck in it.
				apply( wasActive ? '' : department );
			} );
		} );
	}

	function init() {
		Array.prototype.forEach.call(
			document.querySelectorAll( '.mea-careers-feed' ),
			setup
		);
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
